import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme'
import { BoldMedBodyText } from '../styles/Text'
import { statusTypeMap } from '../../util/foiConsts'

const bgColor = {
  new: 'rgba(255, 172, 71, 0.20)',
  departmentAccepted: 'rgba(16, 192, 208, 0.1)',
  ready: 'rgba(45, 204, 112, 0.1)',
  awaitingClient: 'rgba(58, 58, 58, 0.10)',
  awaitingDepartments: 'rgba(241, 196, 15, 0.1)',
  completed: 'rgba(16, 192, 208, 0.1)',
  withdrawn: 'rgba(143, 163, 187, 0.1)'
}

const borderColor = {
  new: 'rgba(255, 172, 71, 1)',
  departmentAccepted: 'rgba(16, 192, 208, 1)',
  ready: 'rgba(45, 204, 112, 1)',
  awaitingClient: 'rgba(58, 58, 58, 1)',
  awaitingDepartments: 'rgba(241, 196, 15, 1)',
  completed: 'rgba(16, 192, 208, 1)',
  withdrawn: 'rgba(143, 163, 187, 1)'
}

const Background = styled.div`
  display: flex;
  width: fit-content;

  color: #333;
  border: ${props => `1px solid ${borderColor[props.status]}`};
  background-color: ${props => bgColor[props.status]};
  border-radius: ${theme.borderRadius.button};
  padding: 8px 15px;
`

const WhiteBackground = styled(Background)`
  padding: 0;
  background-color: #fff;
`

const Status = styled(BoldMedBodyText)`
  text-transform: capitalize;
`

const FOIStatus = ({ status }) => (
  <WhiteBackground>
    <Background status={statusTypeMap[status].type}>
      <Status>{statusTypeMap[status].label}</Status>
    </Background>
  </WhiteBackground>
)

FOIStatus.propTypes = {
  status: PropTypes.oneOf([
    'AWAITING_APPLICATION_FEE',
    'NEW',
    'ACCEPTED',
    'CLARIFYING_SCOPE',
    'SCOPE_APPROVED',
    'AWAITING_ESTIMATES',
    'ESTIMATES_RECEIVED',
    'AWAITING_FEE_ESTIMATE',
    'FEE_ESTIMATE_PAID',
    'AWAITING_DOCUMENTS',
    'DOCUMENTS_RECEIVED',
    'REVIEW_READY',
    'APPROVED',
    'AWAITING_INVOICE',
    'INVOICE_PAID',
    'COMPLETED',
    'ABANDONED',
    'WITHDRAWN'
  ]).isRequired
}

export default FOIStatus
